import React, { useState } from 'react'
import { Typography } from '@mui/material'
import CommentField from 'redesign/components/molecules/comment-field'
import CommentModalHeader from 'redesign/components/molecules/comment-modal-header'
import ModalActionButtons from 'redesign/components/molecules/modal-action-buttons'
import { TASK_DETAILS_PAGE_ROOT_ID } from 'redesign/pages/task-details/constants'
import FullScreenModal from '../FullScreenModal'
import { COMMENT_MODAL_TEST_ID } from './constants'
import { Container } from './styles'
import type { CommentModalProps } from './types'

const CommentModal: React.FC<CommentModalProps> = ({
  commentFieldLabel,
  commentText,
  headerLabel,
  isOpen,
  isRequired = false,
  isSmallScreen,
  onClick,
  onClose,
  placeholder,
  closeAfterAction = false,
  content,
  displayCommentButton = false,
  rootId = TASK_DETAILS_PAGE_ROOT_ID,
}) => {
  const [displayComment, setDisplayComment] = useState(isRequired || !displayCommentButton)
  const [value, setValue] = useState('')
  const [error, setError] = useState(false)

  const handleClose = () => {
    if (!isRequired && displayCommentButton) {
      setDisplayComment(false)
    }

    onClose()
    setValue('')
  }
  const handleClick = () => {
    if (isRequired && !value) {
      setError(true)

      return
    }

    setError(false)
    onClick?.(value)
    setValue('')
    closeAfterAction && handleClose()
  }
  const onChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    setError?.(false)
    setValue(e.target.value)
  }
  const footer = isSmallScreen ? undefined : <ModalActionButtons onClick={handleClick} onClose={handleClose} />

  return (
    <FullScreenModal
      header={
        <CommentModalHeader
          headerLabel={headerLabel}
          onClick={handleClick}
          onClose={handleClose}
          showSendButton={isSmallScreen}
        />
      }
      isOpen={isOpen}
      onClose={handleClose}
      isSmallScreen={isSmallScreen}
      footer={footer}
      noPadding
      rootId={rootId}
    >
      <Container>
        {commentText && <Typography variant="body2">{commentText}</Typography>}
        {content}
        <CommentField
          displayComment={displayComment}
          setDisplayComment={setDisplayComment}
          value={value}
          error={error}
          id={COMMENT_MODAL_TEST_ID}
          isRequired={isRequired}
          placeholder={placeholder}
          commentFieldLabel={commentFieldLabel}
          onChange={onChange}
          testId="comment-modal-field"
        />
      </Container>
    </FullScreenModal>
  )
}

export default CommentModal
